import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useOrgModules } from "@/hooks/useOrgModules";
import { useOrganization } from "@/hooks/useOrganization";

interface ModuleGuardProps {
  module: string;
  children: ReactNode;
  fallbackPath?: string;
}

export function ModuleGuard({ module, children, fallbackPath = "/dashboard" }: ModuleGuardProps) {
  const { hasModule } = useOrgModules();
  const { isLoading } = useOrganization();

  // Enquanto carrega, não redireciona (evita flash)
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasModule(module)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
